import React from "react";
import moment from "moment";
import FieldDisplay from "../common/FieldDisplay";
import {
  getFieldName,
  getFieldText,
  stripHtml,
} from "../../scripts/helperScripts";

function EncounterCard({ encounter }) {
  const openRecord = () => {
    const url = `${
      process.env.REACT_APP_CAREPLAN
    }/dist/EncounterPortal/index.html?contactid=${getFieldText(
      encounter.ccx_patient
    )}&encounterid=${encounter.ccx_encounterid}`;
    window.open(url);
  };

  return (
    <div className="card card-safy">
      <div className="card-header bg-safy1-1 p-1 ps-4 text-white">
        <div className="row">
          <div className="col-10">{encounter.ccx_name}</div>
          <div className="col-2">
            <div className="float-end">
              <i
                onClick={() => openRecord()}
                className="fas fa-pen float-end p-1"
                style={{ color: "#FFFFFF" }}
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div className="card-body card-body-safy">
        <>
          <div className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 row-cols-xl-2 mb-4">
            <div className="col">
              <div className="fw-bold">
                {getFieldName(encounter.ccx_clientprogram)}
              </div>
              <FieldDisplay
                label="Start Time:"
                value={
                  encounter.ccx_starttime &&
                  `${moment(getFieldText(encounter.ccx_starttime)).format(
                    "L"
                  )} ${moment(getFieldText(encounter.ccx_starttime)).format(
                    "LT"
                  )}`
                }
              />
              <FieldDisplay
                label="End Time:"
                value={
                  encounter.ccx_endtime &&
                  `${moment(getFieldText(encounter.ccx_endtime)).format(
                    "L"
                  )} ${moment(getFieldText(encounter.ccx_endtime)).format(
                    "LT"
                  )}`
                }
              />
              <FieldDisplay
                label="Client Diagnosis 1:"
                value={getFieldName(encounter.ccx_clientdiagnosis1)}
              />
            </div>
            <div className="col">
              <FieldDisplay
                label="Delivery Method"
                value={getFieldName(encounter.ccx_deliverymethod)}
              />
              <FieldDisplay
                label="Place of Service:"
                value={getFieldName(encounter.ccx_placeofservice)}
              />
              <FieldDisplay
                label="Provider:"
                value={getFieldName(encounter.ccx_provider)}
              />
              {encounter.ccx_attendingprovider && (
                <FieldDisplay
                  label="Attending Provider:"
                  value={getFieldName(encounter.ccx_attendingprovider)}
                />
              )}
              <FieldDisplay
                label="Recipient Code:"
                value={getFieldName(encounter.ccx_recipientcode)}
              />
            </div>
          </div>
          {encounter.ccx_progressnote && (
            <>
              <div className="h6 pb-0">Progress Note</div>
              <div
                className="p-2 mb-4 w-100 h-100"
                style={{ backgroundColor: "white", whiteSpace: "pre-wrap" }}
              >
                <p>{stripHtml(encounter.ccx_progressnote)}</p>
              </div>
            </>
          )}
          {encounter.ccx_draftsigneduser && (
            <FieldDisplay
              label="Draft Signed User"
              value={getFieldName(encounter.ccx_draftsigneduser)}
            />
          )}
          {encounter.ccx_draftsigneddate && (
            <FieldDisplay
              label="Draft Signed Date"
              value={`${moment(
                getFieldText(encounter.ccx_draftsigneddate)
              ).format("L")}`}
            />
          )}
        </>
      </div>
    </div>
  );
}

export default EncounterCard;
